export default "__VITE_ASSET__mxTNZWAI__"